import React from 'react';
import PropTypes from 'prop-types';

import ProductPropertyTab, { PropertyList } from '../../molecules/product-detail-accordion';

const Sizing = (props) => {
  if (!props.product) return null;

  const sizing = props.product?.product_properties?.filter(
    (property) => property.property_name === 'Sizing Notes'
  );

  if (!sizing || sizing.length === 0) return null;

  return (
    <ProductPropertyTab title="Size / Fit">
      <PropertyList element="ul" like="paragraph-2">
        {
          sizing.map((item) =>
            // eslint-disable-next-line react/no-danger
            <li key={item.id} dangerouslySetInnerHTML={{ __html: item.value }} />)
        }
      </PropertyList>
    </ProductPropertyTab>
  );
};

Sizing.propTypes = {
  product: PropTypes.object.isRequired
};

export default Sizing;
